import classNames from 'classnames';
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import Tooltip from 'react-tooltip-lite';
import { TooltipProps } from 'react-tooltip-lite';
import { themeColors } from 'utils/tailwind/tailwindHelpers';

const TooltipLite: React.FC<
  TooltipProps & {
    disabled?: boolean;
    disabledMessage?: ReactNode;
    id?: string | number;
    padding?: string;
  }
> = ({ disabled, disabledMessage, id, padding, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      if (target === null) return;
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(target) &&
        !target.closest('.tooltip-trigger')
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const clickable = props?.eventToggle === 'onClick';

  return (
    <Tooltip
      {...props}
      isOpen={props?.isOpen ?? (clickable ? isOpen : undefined)}
      content={
        <div ref={tooltipRef} onClick={() => setIsOpen(false)}>
          {disabled && disabledMessage ? disabledMessage : props?.content}
        </div>
      }
      background={themeColors().background['neutral-99']}
      className={classNames('react-tooltip-rounded', props.className)}
      direction='bottom'
      tipContentHover
      tagName='div'
      padding={padding ?? '8px 16px'}
    >
      <div
        className={classNames(
          `tooltip-trigger${id ?? ''}`,
          clickable && 'cursor-pointer',
          disabled && 'pointer-events-none opacity-5'
        )}
        onClick={() => (clickable ? setIsOpen((state) => !state) : undefined)}
      >
        {props.children}
      </div>
    </Tooltip>
  );
};

export default TooltipLite;
